import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Tag } from '@app/core/models/Track';
import { EditTagRequest, EndEditTag } from '@app/library/states/radio-tags.actions';
import { RadioTagsState } from '@app/library/states/radio-tags.state';
import { isEqualFormData } from '@app/shared/utils';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select } from '@ngxs/store';
import { ErrorFormFormat } from '@radioking/shared/common-services';
import { DynamicEnabledPanel } from '@radioking/shared/pannel-manager';
import { cloneDeep } from 'lodash';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'rk-tag-edit',
  templateUrl: './tag-edit.component.html',
  styleUrls: ['./tag-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagEditComponent implements OnInit, DynamicEnabledPanel {
  @Input()
  modalTitle: string;

  @Select(RadioTagsState.editingTag)
  tag$: Observable<Tag>;

  editTagForm: UntypedFormGroup;
  editTagFormErrors: ErrorFormFormat;
  initialFormData: Partial<Tag> = {};

  subscription = new Subscription();
  constructor(private readonly fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.subscription.add(
      this.tag$.subscribe(tag => {
        if (tag) {
          this.modalTitle = tag.name;
          this.createForm(tag);
        }
      }),
    );
  }

  createForm(tag: Tag) {
    this.editTagFormErrors = {
      name: {},
      color: {},
    };
    this.editTagForm = this.fb.group({
      name: [tag.name, Validators.required],
      color: tag.color,
    });
    this.initialFormData = cloneDeep({ ...this.editTagForm.getRawValue() });
  }

  @Dispatch()
  cancelEdit = () => new EndEditTag();

  @Dispatch()
  submit() {
    const tag: Partial<Tag> = {
      name: this.editTagForm.value.name,
      color: this.editTagForm.value.color,
    };

    return new EditTagRequest(tag);
  }

  hasToShowConfirmOnExit(): boolean {
    return false;
  }

  isDirty(): boolean {
    return (
      this.editTagForm &&
      !this.editTagForm.pristine &&
      !isEqualFormData(this.editTagForm.getRawValue(), this.initialFormData)
    );
  }
}
